// src/i18n/localeMeta.js
export const LOCALES = [
  { code: "en", name: "English", badge: "EN" },
  { code: "zh_CN", name: "中文", badge: "中" },
  { code: "ko_KR", name: "한국어", badge: "KR" },
  { code: "vi_VN", name: "Tiếng Việt", badge: "VN" },
  { code: "ja_JP", name: "日本語", badge: "JP" },
];

export function getLocaleMeta(code) {
  return LOCALES.find((x) => x.code === code) || LOCALES[0];
}
